export default __webpack_public_path__ + "static/media/toast-alert.ab94c01e.svg";